import useApi from '../../api/backendApiContext';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import { useQuery } from '@tanstack/react-query';
import { ReactQueryConstants } from '../../commons/constants';
import { QueryStatus } from '../../commons/components/QueryStatus';
import React from 'react';

export const useFetchedTenantNotificationSettings = () => {
  const { billingApi } = useApi();
  const queryCacheManager = useQueryCacheManager();
  const queryKey = queryCacheManager.getTenantNotificationSettingsCacheKey();
  const query = useQuery(queryKey, async () => billingApi.getTenantNotificationSettings(), {
    staleTime: ReactQueryConstants.tenantNotificationSettingsStaleTime,
    refetchInterval: ReactQueryConstants.tenantNotificationSettingsRefetchTime,
  });

  const queryStatusComponent = (
    <QueryStatus
      queryKey={queryKey}
      queryStatus={query.status}
      dataTestPrefix="tenant-notification-settings"
      failedToLoadText="Something went wrong while loading notification settings."
    />
  );

  return { query, queryStatusComponent };
};
